<template>
  <div
    class="page-wrap"
    :class="{
      'hide-right': collapsed,
      'show-right': !collapsed,
    }"
    v-loading="pageLoading"
  >
    <div class="left-box">
      <div class="expand-collapse">
        <el-icon class="icon-wrap" @click="clickCollapseEx">
          <Expand v-if="!collapsed" />
          <Fold v-else />
        </el-icon>
        <div v-if="isExercise" class="remain-time" ref="remainTime">
          <!-- 练习时间：{{ showTimeDown }} -->
        </div>
        <div
          v-else-if="showTimeDown != showTimeStart"
          class="remain-time"
          ref="remainTime"
        >
          剩余时间：{{ showTimeDown }}
        </div>
      </div>
      <iframe :src="ifrUrl" style="width: 100%; height: 100%" />
    </div>

    <div class="right-box">
      <div class="inner">
        <div class="head">
          <h6>答题板</h6>

          <span v-if="isExercise" class="count-down">
            <!-- 练习时间：{{ showTimeDown }} -->
          </span>

          <span
            class="count-down"
            v-else-if="showTimeDown != showTimeStart"
            v-show="remainSeconds >= 0"
          >
            剩余时间：{{ showTimeDown }}
          </span>
        </div>

        <div class="center">
          <el-tabs v-model="taskActive" class="task-tabs">
            <el-tab-pane label="全部业务" :name="1" class="task-all-tab">
              <!-- 全部任务 -->
              <el-collapse v-model="taskAllActive">
                <el-collapse-item
                  :title="item.queName"
                  :name="index"
                  v-for="(item, index) of taskData"
                  :key="item.id"
                >
                  <ul class="task-all-list">
                    <li
                      v-for="(it, idx) of item.sonQuestionVoList || []"
                      :key="item.id"
                    >
                      <p
                        @click="taskSelect(index, idx)"
                        :class="{
                          'is-select':
                            index == taskSelectIndex.index &&
                            idx == taskSelectIndex.idx,
                        }"
                      >
                        {{ it.queName }}
                      </p>
                      <span>{{
                        isExistPoint(it.checkRule) ? "需要作答" : "无需作答"
                      }}</span>
                    </li>
                  </ul>
                </el-collapse-item>
              </el-collapse>
            </el-tab-pane>
            <el-tab-pane label="当前业务" :name="2" class="task-current-tab">
              <template
                v-if="taskSelectIndex.index > -1 && taskSelectIndex.idx > -1"
              >
                <el-segmented
                  v-if="isExercise"
                  class="task-type"
                  v-model="taskTypeActive"
                  :options="taskTypeOptions"
                  size="large"
                />

                <div class="task-type-content">
                  <!-- 题目详情 -->
                  <div v-if="taskTypeActive == 1">
                    <div class="task-title">
                      <h6>{{ taskMainDataActive.queName }}</h6>
                      <p>{{ taskDataActive.queName }}</p>
                    </div>
                    <view-rich-text
                      v-if="taskDataActive.queDesc"
                      :text="taskDataActive.queDesc"
                      imgCanPreviewSelf
                      @imgCanPreviewSelf="imgPreview"
                      videoCanPreviewSelf
                      @videoCanPreviewSelf="videoPreview"
                      :use-base64="false"
                      class="rich-text"
                    />
                    <el-empty v-else description="暂无数据" />
                  </div>
                  <!-- 试题解析 -->
                  <div v-if="taskTypeActive == 2">
                    <view-rich-text
                      v-if="taskDataActive.analyses"
                      :text="taskDataActive.analyses"
                      imgCanPreviewSelf
                      @imgCanPreviewSelf="imgPreview"
                      videoCanPreviewSelf
                      @videoCanPreviewSelf="videoPreview"
                      :use-base64="false"
                      class="rich-text"
                    />
                    <el-empty v-else description="暂无数据" />
                  </div>
                  <!-- 试题答案 -->
                  <div v-if="taskTypeActive == 3" class="task-type-item-3">
                    <el-table
                      v-if="isExistPoint(taskDataActive.checkRule)"
                      :data="getCheckRule(taskDataActive.checkRule)"
                      style="width: 100%; height: 100%"
                      border
                    >
                      <el-table-column
                        prop="label"
                        label="评分点"
                        align="center"
                        width="50"
                      />
                      <el-table-column
                        prop="data"
                        label="正确答案"
                        align="center"
                      >
                        <template #default="{ row }">
                          <pointView :data="row" />
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-empty v-else description="暂无数据" />
                  </div>
                </div>
              </template>
              <el-empty v-else description="请选择一个业务" />
            </el-tab-pane>
          </el-tabs>
        </div>

        <div class="footer">
          <!-- 全部业务 -->
          <el-button
            type="primary"
            v-if="taskActive == 1"
            class="submit-btn"
            @click="handlePaper(true)"
          >
            交卷
          </el-button>
          <!-- 当前业务 -->
          <div
            class="switch-btn"
            v-if="
              taskActive == 2 &&
              taskSelectIndex.index > -1 &&
              taskSelectIndex.idx > -1
            "
          >
            <el-button
              type="default"
              :disabled="checktTaskSelectIndex('prev')"
              @click="taskSelectJump('prev')"
            >
              上一题
            </el-button>
            <el-button
              type="default"
              :disabled="checktTaskSelectIndex('next')"
              @click="taskSelectJump('next')"
            >
              下一题
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <rh-calculator v-model:visible="calVis" />

    <!-- <online-preview-dialog
      title="在线资料"
      :oss-path="currentQa.materials"
      v-model:visible="onlineDataVis"
    /> -->

    <tx-drag-play-dialog :video-id="videoId" v-model:visible="explainVis" />

    <!-- 预览图片 -->
    <imgPreviewer
      ref="imgPreviewerRef"
      v-model:visible="imgPreviewVisible"
      :urlList="imgPreviewUrls"
      :initialIndex="imgPreviewIndex"
    />

    <!-- 预览视频 -->
    <tx-play-dialog
      :video-id="playerId"
      v-model:visible="playerVis"
      v-bind="$attrs"
      playMode="threeTcPlay"
    />
  </div>
</template>

<script setup>
import { findExamInfo, submitPaper } from "@/api/examCenter/exam";
import { getSingleLoginUrl } from "@/api/cssc";
import RhCalculator from "@/components/RhComponent/RhCalculator";
import ExamResultDialog from "@/views/examCenter/common/examResultDialog";
import { ElMessage, ElMessageBox } from "element-plus";
import ViewRichText from "@/components/RichText/ViewRichText.vue";
import TxDragPlayDialog from "@/components/TxPlayer/TxDragPlayDialog.vue";
import { computed } from "vue";
import { numberToCn } from "@/utils/ruoyi.js";
import pointView from "@/components/pointView/index.vue";
import imgPreviewer from "@/components/OnlineWps/imgPreviewerV2.vue";
import TxPlayDialog from "@/components/TxPlayer/TxPlayDialog.vue";
import {baseUrl} from "@/router/index.js";
import {removeToken} from "@/utils/auth.js";
import { localStorageClear, sessionStorageClear } from "@/utils/ruoyi.js";

let intervalId = null;
let remainSeconds = -1; // 考试剩余的秒数
const showTimeStart = "00:00:00";
const showTimeDown = ref(showTimeStart);

const pageLoading = ref(false);
const calVis = ref(false);
const collapsed = ref(false);
const route = useRoute();
const ifrUrl = ref(""); // 考试嵌入链接
const dataInfo = ref({
  questionList: [],
}); // 考试信息，完整数据
const taskData = computed(() => {
  try {
    const sonQuestionVoList = (
      dataInfo.value.questionList[0].sonQuestionVoList || []
    ).map((item) => {
      return Object.assign({}, item, {
        sonQuestionVoList: item.sonQuestionVoList.map((it) => {
          return Object.assign({}, it, {
            checkRule: JSON.parse(it.checkRule || "[]"),
          });
        }),
      });
    });
    return sonQuestionVoList;
  } catch {
    return [];
  }
});
// 全部业务/当前业务
const taskActive = ref(1);
// 全部业务
const taskAllActive = ref([]);
// 是否是练习
const isExercise = computed(() => {
  return (
    dataInfo.value?.exam?.examType == "501" ||
    dataInfo.value?.exam?.examType == "302"
  );
});
// 当前业务分类
const taskTypeActive = ref(1);
const taskTypeOptions = computed(() => {
  const taskTypeOptions = [
    {
      label: "题目详情",
      value: 1,
    },
  ];

  if (isExercise.value) {
    taskTypeOptions.push(
      ...[
        {
          label: "试题解析",
          value: 2,
        },
        {
          label: "试题答案",
          value: 3,
        },
      ]
    );
  }

  return taskTypeOptions;
});

// 当前业务
const taskSelectIndex = ref({
  index: -1,
  idx: -1,
});

// 小题点击
const taskSelect = (index, idx) => {
  Object.assign(taskSelectIndex.value, {
    index,
    idx,
  });

  taskTypeActive.value = 1;
  taskActive.value = 2;
};

// 上一题下一题限制
const checktTaskSelectIndex = (type) => {
  if (taskData.value.length == 0) {
    return true;
  }

  const { index, idx } = taskSelectIndex.value;

  switch (type) {
    case "prev":
      return index == 0 && idx == 0;
      break;

    case "next":
      return (
        index == taskData.value.length - 1 &&
        idx == taskData.value.at(-1).sonQuestionVoList.length - 1
      );
      break;

    default:
      return true;
      break;
  }
};

// 切题跳转
const taskSelectJump = (type) => {
  const { index, idx } = taskSelectIndex.value;

  const idxMax = taskData.value.at(index).sonQuestionVoList.length - 1;

  switch (type) {
    case "prev":
      if (idx >= 1) {
        Object.assign(taskSelectIndex.value, {
          index,
          idx: idx - 1,
        });
      } else {
        Object.assign(taskSelectIndex.value, {
          index: index - 1,
          idx: taskData.value.at(index - 1).sonQuestionVoList.length - 1,
        });
      }

      taskTypeActive.value = 1;
      break;

    case "next":
      if (idx >= idxMax) {
        Object.assign(taskSelectIndex.value, {
          index: index + 1,
          idx: 0,
        });
      } else {
        Object.assign(taskSelectIndex.value, {
          index,
          idx: idx + 1,
        });
      }

      taskTypeActive.value = 1;
      break;

    default:
      break;
  }
};

// 当前大题
const taskMainDataActive = computed(() => {
  try {
    const { index } = taskSelectIndex.value;

    if (index > -1) {
      return taskData.value.at(index);
    }

    return {};
  } catch (e) {
    return {};
  }
});

// 当前题
const taskDataActive = computed(() => {
  try {
    const { index, idx } = taskSelectIndex.value;

    if (index > -1 && idx > -1) {
      return taskData.value.at(index).sonQuestionVoList.at(idx);
    }

    return {};
  } catch (e) {
    return {};
  }
});

// 评分点
const getCheckRule = (checkRule) => {
  if (checkRule instanceof Array && checkRule.length > 0) {
    return checkRule
      .map((item) => item.children)
      .flat()
      .filter((item) => item.data.length > 0);
  }

  return [];
};

onMounted(() => {
  init();
  initPostEvent()
});

async function init() {
  pageLoading.value = true;

  try {
    const getSingleLoginUrlRes = await getSingleLoginUrl(); // 获取登录链接
    ifrUrl.value = getSingleLoginUrlRes.data;
    await fetchInfo();

    pageLoading.value = false;
  } catch (e) {}
}

function fetchInfo() {
  return findExamInfo({
    examStudentInfoId: route.query.id,
  }).then((res) => {
    dataInfo.value = res.data || {};
    taskAllActive.value = Array(taskData.value.length)
      .fill()
      .map((item, index) => index);
    if (isExercise.value) {
      // 练习
      // countUpTimer(dataInfo.value.examStudentInfo.examSeconds);
    } else {
      // 考试
      countDownTimer(dataInfo.value.examStudentInfo.remainSeconds);
    }
  });
}

function consider(laterFlag) {
  dataInfo.value.questionList[currentIdx.value].laterFlag = laterFlag;
}

// 交卷
function handlePaper(byUser) {
  ElMessageBox.confirm("交卷后无法取消，确定要交卷吗？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
    closeOnClickModal: false,
    closeOnPressEscape: false,
  })
    .then(() => {
      pageLoading.value = true;
      submitPaper({
        examStuInfoId: dataInfo.value.examStudentInfo.examStuInfoId,
        examId: dataInfo.value.exam.examId,
        paperId: dataInfo.value.paper.paperId,
      })
        .then((res) => {
          ElMessage.success("交卷成功");
          router.replace({
            name: "ExamAccountAnalysis",
            query: {
              id: dataInfo.value.examStudentInfo.examStuInfoId,
            },
          });
        })
        .catch(() => {
          pageLoading.value = false;
        });
    })
    .catch(() => {});
}

onBeforeUnmount(() => {
  // 销毁实例
  if (intervalId != null) {
    clearInterval(intervalId);
    intervalId = null;
  }
});

function countDownTimer(second) {
  remainSeconds = second;
  showTimeDown.value = formatSeconds(remainSeconds);
  if (intervalId != null) {
    clearInterval(intervalId);
    intervalId = null;
  }
  if (second <= 0) {
    showTimeDown.value = formatSeconds(0);
    return;
  }
  intervalId = setInterval(() => {
    remainSeconds--;
    showTimeDown.value = formatSeconds(remainSeconds);

    if (remainSeconds <= 0) {
      clearInterval(intervalId);
      intervalId = null;
      showTimeDown.value = formatSeconds(0);
      handlePaper(false); // 前端自动交卷
    }
  }, 1000);
}

let currentSeconds = 0;
//正计时：针对练习
function countUpTimer(second) {
  currentSeconds = second;
  showTimeDown.value = formatSeconds(currentSeconds);
  if (intervalId != null) {
    clearInterval(intervalId);
    intervalId = null;
  }
  intervalId = setInterval(() => {
    currentSeconds++;
    showTimeDown.value = formatSeconds(currentSeconds);
  }, 1000);
}

const router = useRouter();

// 做题错误处理器，拦截已交卷等行为
function errorHandler(err) {
  console.log("信息", err);
  if (err?.toString().indexOf("已交卷") > -1) {
    pageLoading.value = false;
    ElMessageBox.alert("考试已交卷", "提示", {
      showClose: false,
      confirmButtonText: "去结果页",
      autofocus: false,
      callback: () => {
        router.replace({
          name: "ExamAnalysis",
          query: {
            id: route.query.id,
          },
        });
      },
    });
  }
}

function formatSeconds(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  // 格式化为两位数
  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(remainingSeconds).padStart(2, "0");

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}

const onlineDataVis = ref(false);

function viewOnlineData() {
  onlineDataVis.value = true;
}

const remainTime = ref();

function clickCollapseEx() {
  collapsed.value = !collapsed.value;
  if (collapsed.value) {
    // 折叠了
    setTimeout(() => {
      remainTime.value && remainTime.value.classList.add("show");
    }, 800);
  } else {
    remainTime.value && remainTime.value.classList.remove("show");
  }
}

const explainVis = ref(false);
const videoId = ref("");

function videoExplain(vid) {
  if (!vid) {
    ElMessage.warning("该题未配置讲解，请与校区老师联系");
    return;
  }
  videoId.value = vid;
  explainVis.value = true;
}

function isExistPoint(checkRule) {
  return checkRule
    .map((item) => item.children)
    .flat()
    .some((item) => item.data.length > 0);
}

// 富文本中图片预览
const imgPreviewerRef = ref();
const imgPreviewVisible = ref(false);
const imgPreviewUrls = ref([]);
const imgPreviewIndex = ref(0);
const imgPreview = ({ urls, index }) => {
  imgPreviewUrls.value = urls;
  imgPreviewIndex.value = index;
  imgPreviewVisible.value = true;
};

// 视频预览
const playerVis = ref(false);
const playerId = ref("");
const videoPreview = (data) => {
  playerId.value = data.playerId;
  playerVis.value = true;
};

function initPostEvent() { // 监听message事件，接收iframe发来的消息
  window.addEventListener('message', event => {
    console.log('消息来源域名：', event);

    if (event?.data?.type == 'notify401') { // 真账系统通知内部已经401，网校踢下去

      console.log('退出登录。。。。。')
      // 1.删除localStorage：适配新首页的nuxt项目(迁移至老网校)
      localStorageClear({
          exclude: ['invoiceV2'],
      });
      sessionStorage.clear()
      removeToken()
      // 2.获取所有cookie，并全部删除
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
      }
      // 3.页面跳转
      const cur = location.pathname + location.search
      const fullPath = cur.substring(cur.indexOf(baseUrl) + baseUrl.length)
      router.push({
        path: '/login',
        replace:true,
        query: {
          redirect: encodeURIComponent(fullPath)
        }
      })
    }
  }, false);
}
</script>

<style scoped lang="scss">
.page-wrap {
  height: 100%;
  position: relative;
  $rightBoxWidth: 400px;
  $transition-time: 0.8s;
  font-size: 14px;
  color: #333333;
  line-height: 1.5;

  .scroll-y {
    overflow-x: hidden;
    overflow-y: auto;
    padding-right: 5px;
    box-sizing: border-box;
  }

  .left-box {
    position: relative;
    margin-right: $rightBoxWidth;
    height: 100%;

    .expand-collapse {
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
      font-size: 20px;
      display: flex;
      border-radius: 4px 0 0 4px;
      background: #40cb99;
      color: #ffffff;
      z-index: 99;
      .icon-wrap {
        width: 50px;
        height: 50px;
      }
      .remain-time {
        font-size: 16px;
        font-weight: 600;
        line-height: 50px;
        padding-right: 10px;
        display: none;
        &.show {
          display: block;
        }
      }
    }
  }

  .right-box {
    position: absolute;
    right: 0;
    top: 0;
    width: $rightBoxWidth;
    height: 100%;
    z-index: 20;
    box-sizing: border-box;
    box-shadow: -2px 0 4px 0 rgba(0, 0, 0, 0.1);
    overflow-x: hidden;
    background-color: #ffffff;

    .inner {
      height: 100%;
      padding: 20px;
      width: $rightBoxWidth;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      .head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex: 0 0 auto;
        overflow: hidden;
        margin-bottom: 20px;

        h6 {
          font-size: 16px;
          font-weight: 600;
        }

        .count-down {
          font-size: 15px;
          color: #ff3051;
          font-weight: 600;
        }
      }

      .center {
        height: 100%;
        overflow: hidden;

        .task-tabs {
          height: 100%;

          :deep() {
            .el-tabs__header {
              .el-tabs__nav {
                width: 100%;
                display: flex;

                .el-tabs__item {
                  font-size: 17px;
                  flex: 1;
                }
              }
            }

            .el-collapse-item__content {
              padding-bottom: 15px;
            }

            .el-tabs__content {
              .el-tab-pane {
                height: 100%;
                overflow: hidden;

                &.task-all-tab {
                  @extend .scroll-y;

                  .el-collapse {
                    border: 0;

                    .el-collapse-item__title {
                      font-size: 15px;
                      font-weight: bold;
                    }

                    .task-all-list {
                      li {
                        display: flex;

                        & + li {
                          margin-top: 15px;
                        }

                        > p {
                          cursor: pointer;
                          width: 100%;
                          overflow: hidden;

                          &.is-select {
                            color: #409eff;
                          }

                          &:hover {
                            color: #409eff;
                          }
                        }

                        > span {
                          flex: 0 0 auto;
                          overflow: hidden;
                          margin-left: 10px;
                        }
                      }
                    }
                  }
                }

                &.task-current-tab {
                  display: flex;
                  flex-direction: column;

                  .task-type {
                    flex-shrink: 0;
                    width: 100%;
                    margin-bottom: 20px;
                  }

                  .task-type-content {
                    width: 100%;
                    flex-grow: 1;
                    @extend .scroll-y;

                    .task-title {
                      background-color: #f5f5f5;
                      padding: 10px;
                      border-radius: 8px;
                      margin-bottom: 15px;

                      h6 {
                        font-size: 16px;
                        font-weight: bold;
                        margin-bottom: 5px;
                      }
                    }

                    .task-type-item-3 {
                      height: 100%;

                      * {
                        font-size: 12px;
                      }

                      .el-table__cell {
                        padding: 0;
                      }

                      .cell {
                        padding: 4px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      .footer {
        flex: 0 0 auto;
        overflow: hidden;
        margin-top: 20px;

        .el-button {
          width: 100%;
          height: 45px;
          font-size: 16px;
        }

        .switch-btn {
          width: 100%;
          display: flex;
        }
      }
    }
  }

  &.show-right {
    .left-box {
      transition: $transition-time margin-right;
    }

    .right-box {
      transition: $transition-time width;
    }
  }

  &.hide-right {
    .left-box {
      transition: $transition-time margin-right;
      margin-right: 0;
    }

    .right-box {
      transition: $transition-time width;
      width: 0;
    }
  }
}
</style>
